import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

// components & containers
import * as fromComponents from './components';
import * as fromContainers from './containers';

/*  combined common modules into one file */
import { PaginationComponent } from '../shared/components/pagination/pagination.component';
import { SharedModule } from '../shared/shared.module';
import { effects } from '../store';
import * as fromServicesReducer from '../store/reducers/services.reducer';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    PaginationComponent,

    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatDialogModule,

    ReactiveFormsModule,
    ScrollingModule,

    StoreModule.forFeature('services', fromServicesReducer.reducer),
    EffectsModule.forFeature(effects),
  ],
  exports: [RouterModule],
  declarations: [...fromComponents.components, ...fromContainers.containers],
})
export class InventoryModule {}
